<mat-form-field fxFlex="100">
  <input matInput [matDatepicker]="picker" placeholder="{{placeholder}}" [(ngModel)]="pickerValue" (change)="refreshPicker($event)" (dateChange)="refreshPicker($event)" [disabled]="disabled">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
</mat-form-field>
<mat-datepicker #picker></mat-datepicker>
